export function watchForReveals() {
	const config = {
		root: null,
		rootMargin: '0px 0px -20% 0px',
		// threshold: 0.1,
	};

	const instances = Array.from(document.querySelectorAll('[data-reveal]'));

	let observer = null;

	if ('IntersectionObserver' in window) {
		observer = new IntersectionObserver(handleIntersection, config);
	}
	else {
		return;
	}

	instances.forEach(instance => {
		prepareReveal(instance);
		observer.observe(instance);
	});
}

function handleIntersection(entries, observer) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			reveal(entry.target);
		}
	});
}

function prepareReveal(element) {
	if (element) {
		element.classList.add('reveal-waiting');
	}
}

function reveal(element)
{
	if (element) {
		element.classList.remove('reveal-waiting');
		element.classList.add('revealed');
	}
}




// WEBPACK FOOTER //
// ./scripts/modules/reveals.js